import { createContext, useContext } from 'react';

// Create Context
export const LanguageContext = createContext();

// Custom Hook to use the Language Context
export const useLanguage = () => useContext(LanguageContext);
